<template>
  <div class="dataBox">
    <span>您的入会申请已通过初审，正在进行终审，请耐心等待...</span>
  </div>
</template>

<script>
export default {
  name: 'processDataexamine2'
}
</script>

<style scoped>
.dataBox{
  padding-top: 180px;
}
.dataBox span{
  font-size: 18px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/joinprocess/processDataexamine2.vue